<template>
  <beautiful-chat
    v-if="chatAtual != undefined && chatAtual.id"
    :participants="chatAtual?chatAtual.participantesChat:[]"
    :titleImageUrl="titleImageUrl"
    :title="chatAtual.nome?chatAtual.nome:''"
    :onMessageWasSent="onMessageWasSent"
    :messageList="chatAtual?chatAtual.mensagensParaChat:[]"
    :newMessagesCount="newMessagesCount"
    :isOpen="isChatOpen"
    :close="closeChat"
    :icons="icons"
    :open="openChat"
    :showEmoji="true"
    :showFile="false"
    :showTypingIndicator="showTypingIndicator"
    :colors="colors"
    :alwaysScrollToBottom="alwaysScrollToBottom"
    :messageStyling="messageStyling"
    :showEnterWindow="false"
    :fullScreen="true"
    @onType="handleOnType"
    @edit="editMessage"
  >
    <template slot="dropDownMenu">
      <MenuChat />
    </template>
  </beautiful-chat>
</template>

<script>
import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png';
import OpenIcon from 'vue-beautiful-chat/src/assets/chat-icon.png';
import FileIcon from 'vue-beautiful-chat/src/assets/file.svg';
import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg';
import { mapActions, mapGetters } from 'vuex';
import MenuChat from './MenuChat.vue';

export default {
  components: {
    MenuChat,
  },
  data() {
    return {
      chat: 'chat',
      icons: {
        open: {
          img: OpenIcon,
          name: 'default',
        },
        close: {
          img: CloseIcon,
          name: 'default',
        },
        file: {
          img: FileIcon,
          name: 'default',
        },
        closeSvg: {
          img: CloseIconSvg,
          name: 'default',
        },
      },
      participants: [],
      titleImageUrl: '',
      newMessagesCount: 0,
      isChatOpen: false,
      showTypingIndicator: '',
      colors: {
        header: {
          bg: '#20a8d8',
          text: '#ffffff',
        },
        launcher: {
          bg: '#4e8cff',
        },
        messageList: {
          bg: '#ffffff',
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff',
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222',
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867',
        },
      },
      alwaysScrollToBottom: false,
      messageStyling: true,
      showEntrar: true,
    };
  },
  async created() {
    this.sockets.listener.subscribe(`digitando-chat-${this.chatAtual.id}`, (email) => {
      if (email !== this.usuarioLogado.email) {
        this.showTypingIndicator = email;
        setTimeout(() => {
          this.showTypingIndicator = '';
        }, 1000);
      }
    });
    this.sockets.listener.subscribe(
      `entrou-participantes-chat-${this.chatAtual.id}`,
      (participante) => {
        this.entrouParticipantes(participante);
      },
    );
    await this.buscarCoresChat();
  },
  mounted() {
    if (this.coresChat && this.coresChat.value) {
      this.colors = JSON.parse(this.coresChat.value);
    }
  },
  computed: {
    ...mapGetters(['usuarioLogado', 'chatAtual', 'coresChat']),
  },
  methods: {
    ...mapActions(['mandarMensagem', 'entrouParticipantes', 'buscarCoresChat']),
    onMessageWasSent(message) {
      // called when the user sends a message
      this.mandarMensagem({
        mensagemChat: message,
        usuario: this.usuarioLogado,
        chat: this.chatAtual,
        socket: this.$socket,
      });
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false;
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {
      this.$socket.emit('digitando', {
        chatId: this.chatAtual.id,
        email: this.usuarioLogado.email,
      });
    },
    editMessage(message) {
      const m = this.messageList.find((m) => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
  },
};
</script>

<style scoped>

.sc-message--text {
  margin-right: 3%;
}

</style>
